/* eslint-disable hubspot-dev/no-unsafe-storage */

// @ts-expect-error dependency missing types
import SafeStorage from 'SafeStorage';
const logAction = (action, published) => {
  if (SafeStorage.getItem('MOBILE_DEBUG')) {
    if (published) {
      // eslint-disable-next-line no-console
      console.log('Published action to native API', action);
    } else {
      // eslint-disable-next-line no-console
      console.log('Can not reach native code, but would have sent:', action);
    }
  }
};
const sendToIOS = action => window.webkit.messageHandlers.callback.postMessage(action);
const sendToAndroid = action => window.Android.postMessage(JSON.stringify(action));

/**
 * @description Attempts to publish an action on all native APIs,
 * short circuiting if one succeeds
 * @param {Object} action
 * @param {String} action.name the name of the action to send
 */
export const sendNativeAction = action => {
  const publishStrategies = [sendToIOS, sendToAndroid];
  const len = publishStrategies.length;
  let i = 0;
  for (i; i < len; i++) {
    try {
      publishStrategies[i](action);
      break;
    } catch (__e) {
      // ignore
    }
  }
  const published = i !== len;
  logAction(action, published);
};